import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import InvoiceMap from "./InvoiceMap";
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import CommonButton from "components/commonButton/CommonButton";
import { useNavigate } from "react-router-dom";

function InvoiceDetails() {

  const navigate = useNavigate();

  return (
    <Box>
      <Grid container className="justifyBetween mb20">
        <Grid item xs={12} md={6} >
          <Box className="alignStart">
            <ArrowBackIosRoundedIcon onClick={() => navigate(-1)}  className="font24 colorGrey" role="presentation" />
            <Typography variant="head3" className="fw600 pl20" sx={{color: "#000000"}}>
              Trip #36477541-2 <Typography variant="body1" component="span" sx={{background: "#0F538D", padding: "5px 10px"}} className="fw600 colorWhite">Completed</Typography>
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} container justifyContent="flex-end">
        <CommonButton name="Download PDF" btnClass={"btnMedium btnYellow"} iconPlace="back" iconType={"download"} />
        </Grid>
      </Grid>
      <InvoiceMap />
    </Box>
  );
}

export default InvoiceDetails;
